import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { LoginService } from '@core/services/login.service';

export const AuthResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot) => {
    return inject(LoginService).resolveRootRoute(route);
};
